import css_img from '../assets/img/css.svg'
import html_img from '../assets/img/html.svg'
import javascript_img from '../assets/img/javascript.svg'
import typescript_img from '../assets/img/typescript.svg'
import react_img from '../assets/img/react.svg'
import bootstrap_img from '../assets/img/bootstrap.svg'
import nodejs from '../assets/img/nodejs.svg'
import npm from '../assets/img/npm.svg'
import angular from '../assets/img/angular.svg'
import mysql from '../assets/img/mysql.svg'

export const skillsData = [
    {
        img: html_img,
        name: 'HTML',
        width: 256,
        height: 290
    },
    {
        img: css_img,
        name: 'CSS',
        width: 256,
        height: 290
    },
    {
        img: javascript_img,
        name: 'Javascript',
        width: 256,
        height: 256
    },
    {
        img: typescript_img,
        name: 'Typescript',
        width: 256,
        height: 256
    },
    {
        img: react_img,
        name: 'React',
        width: 256,
        height: 228
    },
    {
        img: bootstrap_img,
        name: 'Bootstrap',
        width: 256,
        height: 256
    },
    {
        img: nodejs,
        name: 'nodejs',
        width: 256,
        height: 289
    },
    {
        img: npm,
        name: 'Npm',
        width: 2500,
        height: 2500
    },
    {
        img: angular,
        name: 'Angular',
        width: 256,
        height: 272
    },
    {
        img: mysql,
        name: 'MySQL',
        width: 256,
        height: 252
    }
]
